module.exports = __webpack_public_path__ + "static/profile-94dc6ae9023e55ee2c2605bc839c7b42.jpeg";